<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    append-to-body
    :close-on-click-modal="false"
    top="5vh"
    :before-close="handleClose">
    <div class="body-wrapper" :style="{height: height}">
      <FlowViewDom v-if="dialogVisible" :taskId="task_id" :isEdit="is_edit" :masterId="master_id" :sheetId="sheet_id" :batchNumberNo="batchNumber" @handleFlowHandle="onConfirm" />
    </div>
  </el-dialog>
</template>

<script>
import FlowViewDom from "../Flow/FlowViewDom";
export default {
  name: "ViewFlow",
  components: {FlowViewDom},
  data() {
    return {
      dialogVisible: false,
      title: "",
      width: "90vw",
      height: "80vh",
      master_id:0,
      sheet_id:0,
      task_id:0,
      is_edit:false,
      batchNumber:"",
      callback:null,
    };
  },
  methods:{
    show({title, task_id, master_id=0, sheet_id=0, is_edit=false, batchNumber="", width="90vw", height="80vh"},callback){
      this.title = title;
      this.task_id = task_id;
      this.master_id = master_id;
      this.sheet_id = sheet_id;
      this.is_edit = is_edit;
      this.batchNumber = batchNumber;
      this.width = width;
      this.height = height;
      this.dialogVisible = true;
      this.callback = callback;
    },
    onConfirm(item){
      typeof this.callback=== 'function' && this.callback(item);
      this.dialogVisible = false;
    },
    handleClose(done) {
      this.$emit("close", done);
      if (this.callback) {
        this.callback=null
      }
      this.dialogVisible = false;
    },
    hidden(){
      if (this.callback) {
        this.callback=null
      }
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}
.body-wrapper{
  width: 100%;
  height: 80vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ViewFlow.vue